import { Image, Spin, UploadFile } from "antd";
import { useCallback, useMemo, useRef, useState, ReactNode } from "react";
import { RcFile } from "antd/lib/upload/interface";
import { LoadingOutlined } from "@ant-design/icons";
import "./UploadImageAndVideo.scss";
import classNames from "classnames";
import { UploadIcon, EyeIcon } from "../../icons-and-animations/icons";

const MAX_IMAGE_SIZE = 2 * 1024 * 1024; // 2MB
const MAX_VIDEO_SIZE = 30 * 1024 * 1024; //  10MB
const VIDEO_PREVIEW_DEFAULT =
  "data:image/png;base64,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";

interface UploadError {
  hasError: boolean;
  message: ReactNode | null;
}

interface PreviewState {
  url: string;
  isOpen: boolean;
}

interface BaseUploadImageAndVideoProps {
  value: string;
  isDisabled?: boolean;
  fileType: "image" | "video";
  isLocalValidation?: boolean;
  customValidation?: (file: RcFile) => { message: string; isValid: boolean };
  onChange?: (value: string) => void;
}

interface WithUploadAssetToProject extends BaseUploadImageAndVideoProps {
  uploadAssetToProject: (
    file: File | UploadFile<any>,
    { s3Folder, projectId }: { s3Folder: string; projectId?: string },
    cb?: (key: string) => void,
    progressCallback?: any
  ) => Promise<void>;
  customUploadFile?: never;
}

interface WithCustomUploadFile extends BaseUploadImageAndVideoProps {
  customUploadFile: (file: RcFile) => Promise<void>;
  uploadAssetToProject?: never;
}

interface WithBothUploadMethods extends BaseUploadImageAndVideoProps {
  uploadAssetToProject: (
    file: File | UploadFile<any>,
    { s3Folder, projectId }: { s3Folder: string; projectId?: string },
    cb?: (key: string) => void,
    progressCallback?: any
  ) => Promise<void>;
  customUploadFile: (file: RcFile) => Promise<void>;
}

// contains all possible props - want to enforce that at least one upload method is passed
type UploadImageAndVideoProps =
  | WithUploadAssetToProject
  | WithCustomUploadFile
  | WithBothUploadMethods;

const getInstructionsMessage = (fileType: "image" | "video"): string => {
  if (fileType === "image") {
    return "Supports: PNG, JPG";
  }
  return "Upload a video file";
};

const UploadImageAndVideo = ({
  value,
  isDisabled = false,
  uploadAssetToProject,
  fileType = "image",
  onChange = () => {},
  isLocalValidation = true,
  customValidation,
  customUploadFile,
}: UploadImageAndVideoProps) => {
  const [preview, setPreview] = useState<PreviewState>({
    url: "",
    isOpen: false,
  });
  const [error, setError] = useState<UploadError>({
    hasError: false,
    message: null,
  });
  const [isImageUploading, setIsImageUploading] = useState<boolean>(false);
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const triggerFileSelect = useCallback(() => {
    fileInputRef.current?.click();
  }, []);

  const accept = useMemo(
    () => (fileType === "image" ? "image/png, image/jpeg" : "video/mp4"),
    [fileType]
  );

  const localSizeValidation = useMemo(
    () => (file: File) => {
      const validationSize =
        fileType === "image" ? MAX_IMAGE_SIZE : MAX_VIDEO_SIZE;
      if (file.size > validationSize) {
        setError({
          hasError: true,
          message: (
            <div className="error-message">
              File too large.
              <br />
              Max size: {fileType === "image" ? "2MB" : "10MB"}.
            </div>
          ),
        });
        return false;
      }
      return true;
    },
    [fileType]
  );

  const handleFileChange = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>) => {
      const selectedFile = event.target.files?.[0] as RcFile | null;
      if (!selectedFile) {
        return;
      }

      try {
        setError({ hasError: false, message: null });
        setIsImageUploading(true);

        if (isLocalValidation) {
          const isValid = localSizeValidation(selectedFile);
          if (!isValid) {
            return;
          }
        }

        if (customValidation) {
          const { message, isValid } = customValidation(selectedFile);
          if (!isValid) {
            setError({
              hasError: true,
              message: <div className="error-message">{message}</div>,
            });
            return;
          }
        }

        if (customUploadFile) {
          await customUploadFile(selectedFile);
          setError({ hasError: false, message: null });
        } else {
          await uploadAssetToProject(
            selectedFile,
            { s3Folder: fileType },
            (key: string) => {
              onChange(key);
              setError({ hasError: false, message: null });
            }
          );
        }
      } catch (error) {
        setError({
          hasError: true,
          message: <div className="error-message">Failed to upload</div>,
        });
      } finally {
        setIsImageUploading(false);
      }
    },
    [
      fileType,
      isLocalValidation,
      customValidation,
      customUploadFile,
      uploadAssetToProject,
      onChange,
      localSizeValidation,
    ]
  );

  return (
    <div
      className={classNames("upload-image-and-video-container", {
        "container-disabled": isDisabled,
        "container-error": error.hasError,
      })}
    >
      <div className="upload-inner-wrapper">
        {isImageUploading ? (
          <div className="loading-container">
            <Spin indicator={<LoadingOutlined spin />} />
            Uploading...
          </div>
        ) : (
          <>
            <div className="image-item-container">
              <Image
                src={fileType === "video" ? VIDEO_PREVIEW_DEFAULT : value}
                width={90}
                height={90}
                loading="lazy"
                preview={false}
                placeholder={
                  <div className="image-placeholder">
                    <LoadingOutlined />
                  </div>
                }
              />
            </div>
            <div
              className={classNames("upload-item-container", {
                error: error.hasError,
              })}
            >
              <div className="button-item-container">
                {!error.hasError && (
                  <span
                    className="button-item-eye"
                    onClick={() => {
                      setPreview({ url: value, isOpen: true });
                    }}
                  >
                    <EyeIcon />
                  </span>
                )}
                {!isDisabled && (
                  <span
                    className="button-item-upload-icon"
                    onClick={triggerFileSelect}
                  >
                    <UploadIcon />
                  </span>
                )}
              </div>
              <input
                disabled={isDisabled}
                type="file"
                id="file-upload"
                ref={fileInputRef}
                accept={accept}
                className="upload-input"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <div className="upload-item-container-message">
                {error.hasError ? (
                  <div className="upload-item-container-message-error">
                    {error.message}
                  </div>
                ) : (
                  <div className="upload-item-container-message-success">
                    {getInstructionsMessage(fileType)}
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>

      {preview.url && (
        <Image
          wrapperStyle={{ display: "none" }}
          preview={{
            destroyOnHidden: true,
            visible: preview.isOpen,
            onVisibleChange: (visible) =>
              setPreview((prev) => ({ ...prev, isOpen: visible })),
            afterOpenChange: (visible) =>
              !visible && setPreview({ url: "", isOpen: false }),
            toolbarRender: () => null,
            ...(fileType === "video"
              ? {
                  imageRender: () => (
                    <video
                      muted
                      width="fit-content"
                      controls
                      src={preview.url}
                      style={{ maxHeight: "70%" }}
                    />
                  ),
                }
              : {}),
          }}
          src={preview.url}
        />
      )}
    </div>
  );
};

export default UploadImageAndVideo;
